import { IKeyInitiativeSuggestion } from '../../../model/types'

/**
 * Renders the parsed suggestions array into a readable string so `ReadOnlyField`
 * doesn't print `[object Object]`. Empty input renders as an empty string (which
 * `ReadOnlyField` shows as `-`).
 */
export const formatKeyInitiativeSuggestions = (suggestions: IKeyInitiativeSuggestion[]): string => {
  if (!suggestions?.length) {
    return ''
  }

  return suggestions
    .map(({ keyInitiativeId, matchPercent }) => `KI ${keyInitiativeId} · ${matchPercent}%`)
    .join(', ')
}
